import { Section, SelectorIdentifier } from '../../models';
import { ForeSITEXDDataDeliveryFieldIds, ForesiteXDSectionIds } from './base-config-models';
import { field } from '../../core/field-schema';
import { required } from '../../core/validator-builders';
import { FastModeOption, MonitoringPointElement } from '../../../models/location-card.model';
import { ForesiteXDLocationCardState } from './models';

/**
 * ForeSITE Data Delivery Configuration Section
 */
export const dataDelivery = (state: ForesiteXDLocationCardState): Section => {
    const config = state.monitorConfiguration;

    return {
        info: {
            id: ForesiteXDSectionIds.DataDelivery,
            title: 'ADD_EDIT.ADD_EDIT_DATA_DELIVERY',
            displayTitle: true,
            expandable: true,
            expanded: false,
        },
        rows: [
            // Normal Rate and Fast Mode Row
            {
                info: {
                    id: 'delivery-rates-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.select<MonitoringPointElement, number>(ForeSITEXDDataDeliveryFieldIds.NormalIntervalHours, 'normalIntervalHours', {
                        label: 'ADD_EDIT.INPUT_PLACEHOLDER_NORMAL_RATE',
                        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_NORMAL_RATE',
                        panelClass: 'custom-width',
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        value: config?.normalIntervalHours ?? 24,
                        validators: [
                            required({
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                        ],
                        optionsSelector: SelectorIdentifier.ForeSiteNormalDeliveryList,
                    }),
                    field.select<FastModeOption, boolean>(ForeSITEXDDataDeliveryFieldIds.FastModeEnabled, 'fastModeEnabled', {
                        label: 'ADD_EDIT.INPUT_PLACEHOLDER_FAST_RATE',
                        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_FAST_RATE',
                        panelClass: 'custom-width',
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        value: config?.fastModeEnabled ?? false,
                        validators: [
                            required({
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                        ],
                        optionsSelector: SelectorIdentifier.FastModeOptions,
                    }),
                ],
            },
        ],
    };
};
